import React from 'react';
import { BaasicFieldSelectTemplate } from 'themes/components';

function BaasicFieldSelect(props) {
	return <BaasicFieldSelectTemplate {...props} />;
}

export default BaasicFieldSelect;



// WEBPACK FOOTER //
// ./src/core/components/select/BaasicFieldSelect.jsx